export const SHOULD_USE_GLOBAL_BOUND_KEY = 'shouldUseGlobalErrorBoundary'
